import React, { Fragment } from 'react';
import { Hero, Press } from './../../components';
import ExPubSwiper from './ExPubSwiper';

export default (props) => {
  return (
    <Fragment>
      {(props.data.hero_slider) && <Hero sliderContent={props.data.hero_slider} height={'64vh'}/>}
      <section className={(!props.data.hero_slider) ? 'ex-pub-wrapper no-slider' : 'ex-pub-wrapper'}>
        <article className="ex-pub-primary">
          <div className="ex-pub-info">
            <h1 className="medium-header publication-header" dangerouslySetInnerHTML={{ __html: props.data.headline }} />
            {props.children}
          </div>
          <div className="intro">
            <div className="formatted-markup" dangerouslySetInnerHTML={{ __html: props.data.content }} />
          </div>
        </article>
      </section>
      <ExPubSwiper Slides={props.data.gallery}/>
      {(props.data.press) &&
        <section className="ex-pub-secondary">
          <Press PressData={props.data.press} />
        </section>
      }
    </Fragment>
  );
};





// WEBPACK FOOTER //
// ./src/pages/ex-pub-gallery/ExPubDetail.js